module.exports = __webpack_public_path__ + "media/images/common/lp/bg-ctaBox--left-2985853d0f209bf48b4ddd4cb7b562c5.png";